export enum OperationRequestStatus {
  READY = "READY",
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  EXECUTED = "EXECUTED",
  SUPERSEDED = "SUPERSEDED",
}
